import { useState } from 'react'
import { gql } from '@apollo/client'
import { Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { PROFILER_START_MUTATION, PROFILER_STOP_MUTATION } from '../../../graphql.js'
import { handleGraphQLErrors } from '../../../utils.js'
import ProfilerRuns from './ProfilerRuns.js'
import ProfilerRunDetail from './ProfilerRunDetail.js'
import PackageSource from './PackageSource.js'

const PROFILER_START = gql(PROFILER_START_MUTATION)
const PROFILER_STOP = gql(PROFILER_STOP_MUTATION)

export default function Profiler() {
  console.log('Profiler rendered')

  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function executeMutation(mutation) {
    try {
      setSpinner(true)
      const { data, errors } = await window.apolloClient.mutate({ mutation: mutation })
      console.log('data: ', { data })
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    }
    setSpinner(false)
  }
 
  async function executeAction(action) {
    if (action === 'start') {
      await executeMutation(PROFILER_START)
    }
    if (action === 'stop') {
      await executeMutation(PROFILER_STOP)
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <div style={{ display: 'inline-block', textAlign: 'center', margin: '10px', verticalAlign: 'top' }}>
        <h1>Profiler</h1>
        <div><Button color="success" onClick={() => executeAction('start')}>Start Profiler</Button></div>
        <div style={{ marginTop: '10px' }}><Button color="danger" onClick={() => executeAction('stop')}>Stop Profiler</Button></div>
        <ProfilerRuns />
        <ProfilerRunDetail />
      </div>
      <div style={{ display: 'inline-block', margin: '10px' }}>
        <PackageSource />
      </div>
    </div>
  )
}
